import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Welcome from "../pages/onboarding/Welcome";
import PersonalInfo from "../pages/onboarding/PersonalInfo";
import ContactInfo from "../pages/onboarding/ContactInfo";
import GetToKnowYou from "../pages/onboarding/GetToKnowYou";
import AdditionalServices from "../pages/onboarding/AdditionalServices"
import TellUsMore from "../pages/onboarding/TellUsMore"
import SubscriptionPage from "../pages/onboarding/subscription/SubscriptionPage"
import TermsAndConditions from "../pages/onboarding/TermsAndConditions"
import SubscriptionOptions2 from "../pages/onboarding/SubscriptionOptions2";
import SubscriptionOptions from "../pages/onboarding/SubscriptionOptions";
import SubscriptionConfirmation from "../pages/onboarding/SubscriptionConfirmation";
import SubscriptionConfirmation2 from "../pages/onboarding/SubscriptionConfirmation2";

import PaymentForm from "../pages/onboarding/paymentForm";


const UserOnboarding = ({ onOnboardingComplete }) => {
  const [onboardingData, setOnboardingData] = useState({});
  return (
    <Routes>
      <Route path="/welcome" element={<Welcome onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/personal-info" element={<PersonalInfo onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/contact-info" element={<ContactInfo onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/subs" element={<SubscriptionOptions onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/subs2" element={<SubscriptionOptions2 onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/confirm-subs" element={<SubscriptionConfirmation onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/confirm-subs2" element={<SubscriptionConfirmation2 onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/payment" element={<PaymentForm onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/get-to-know-you" element={<GetToKnowYou onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      {/* <Route path="/additional-services" element={<AdditionalServices onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} /> */}
      <Route path="/subscription-page" element={<SubscriptionPage onboardingData={onboardingData} setOnboardingData={setOnboardingData} />} />
      <Route path="/tell-us-more" element={<TellUsMore onboardingData={onboardingData} setOnboardingData={setOnboardingData} onOnboardingComplete={onOnboardingComplete} />} />
    </Routes>
  );

};

export default UserOnboarding;